import { ApiResourceBaseClass as o } from "./baseApiCalls.js";
const r = "more_hours";
class R extends o {
  /**
   * List available **More Hour IDs** available for a given business category, including their translated names for the given language.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/more_hours/list`
   *
   * @param {MoreHoursListParams} queryParams - Parameters for query. Category and country determine the list of avaliable More Hours. Lang is optional and is used to translate the names of the different More Hours.
   * @returns {Promise<MoreHoursListReceivedData>} A promise resolving to the data containing the available More Hours.
   */
  getMoreHours = async (s) => {
    const { data: e } = await this.get(
      `${r}/list`,
      s
    );
    return e;
  };
}
export {
  R as MoreHours
};
